module.exports = __webpack_public_path__ + "img/bth_bed_left_beibu_sel.fb1492e5.png";